export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig();

  if (process.client && config.public.GTAG_ID) {
    // Carregar Google Analytics
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${config.public.GTAG_ID}`;
    document.head.appendChild(script);

    // Configurar gtag
    window.dataLayer = window.dataLayer || [];
    function gtag(..._args: unknown[]) {
      window.dataLayer?.push(arguments);
    }

    gtag('js', new Date());
    gtag('config', config.public.GTAG_ID, {
      debug_mode: config.public.GTM_DEBUG === 'true',
      send_page_view: false,
    });

    window.gtag = gtag;
  }
});

declare global {
  interface Window {
    dataLayer?: any[];
    gtag: (...args: any[]) => void;
  }
}
